export enum ApprovalStatus {
  Rejected,
  Accepted,
}
